// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Base_URL } from "../url";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Check for existing user session on initial load
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const storedUser = localStorage.getItem("userDetails");
        console.log(storedUser, "storedUser");

        if (storedUser) {
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true); // Fixed typo here
          // navigate('/home');

          console.log("runs here");
        } else {
          console.log("check else con");
          setUser(null);
          setIsAuthenticated(false);
          navigate("/");
        }
      } catch (error) {
        console.error("Auth check failed:", error);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  // Login function
  const login = async (username, password) => {
    try {
      const response = await axios.post(`${Base_URL}/Logins`, {
        username,
        password,
      });


            if (response.status !== 200) {
                throw new Error('Login failed');
            }
             toast.success("🎉 Login Successfully");
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("username", username);
            localStorage.setItem("userDetails", JSON.stringify(response.data.userDetails));
            localStorage.setItem("isMicrosoftUser", "false");
            setUser(response.data.userDetails); // Fix: Don't stringify here
            setIsAuthenticated(true);
            navigate('/home'); // Uncomment this to redirect after login
            return true;
        } catch (error) {
            console.error('Login error:', error);
            toast.error(`🦄 ${error.response?.data?.message || error.message}`);
            return false;
        }
    };

    // Logout function
    const logout = () => {
        localStorage.removeItem('userDetails');
        setUser(null);
        setIsAuthenticated(false);
        navigate('/');
    };


  // Value provided to consumers
  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access to context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
